export const Currencies = [
  { key: "EUR", text: "€", value: "EUR" }, // euro
  { key: "USD", text: "$", value: "USD" }, // US dollar
  { key: "GBP", text: "£", value: "GBP" }, // Livre Sterling UK
  { key: "JPY", text: "¥", value: "JPY" }, // Yen Japonais
  { key: "CNY", text: "元", value: "CNY" }, // Yuan Chinois
  { key: "CHF", text: "Fr", value: "CHF" }, // Franc Suisse
  { key: "CAD", text: "$", value: "CAD" }, // dollar canadien
  { key: "AUD", text: "$", value: "AUD" }, // dollar australien
  { key: "SGD", text: "$", value: "SGD" }, // dollar singapour
  { key: "HKD", text: "$", value: "HKD" }, // dollar hong kong
  { key: "BRL", text: "R$", value: "BRL" }, // real bresilien
  { key: "RUR", text: "₽", value: "RUR" }, // rouble russe
  { key: "XOF", text: "FCFA", value: "XOF" } // Franc CFA Afrique de l'Ouest
]



// WEBPACK FOOTER //
// ./src/constants/Currencies.js